import Vue from 'vue';
import Vuex from 'vuex';
import ajax from '../common/ajax'
import global from '../Global.vue'//引用文件
import VueCookies from 'vue-cookies';

Vue.use(Vuex);

let store = new Vuex.Store({
    state: {
        school_logo: 'https://oss.qsxueli.com/xuexi.qsxueli.com/pc/images/headLogo.png',
        qiFocus: '',
        hideType: '',
        layout: 0,
        defaultIndex:'index',           // 首页的页面
        activeIndex:'',            // 顶部默认选项
        visitor: false,     // 是否开启游客模式
        pwd_exp_check: false,  //   is_expire: 1需要修改密码 / 0不需要修改密码, msg: 弹窗hed
        research_institute:true, //是否是研究院
        app_config_load: false,                 // 配置文件是否加载中
        app_config:{
            state:{}
        },
        identity_list:[],  //学籍列表
        titleAfter: "",                         //标题尾巴
        // 页面模板元素
        template: {
            head:{
                logo: true,
                menu:{
                    show: true,
                    index: true,
                    pIteamGroup: true,
                    exam_list: false,
                    chengji: true,
                    biji: true,
                    tongji: true,
                    problem: true,
                    payments:true,
                    material: true,
                    own_examination: true,
                    course_selection: false,
                    certificate_download: false,
                    announcement_list: false,
                    userIndex: true,
                    exam_uinfo:false,
                    graduate_form: true,
                },
                wechatProgram: true,
                new_message: true,
                rangeHeader:{
                    logo: true,
                }
            },
            index:{
                live_list: true,
            },
            login:{
                components: 'qsxueli',
                login_port: true,
                login:{
                    image_captcha: true,
                    captcha: true,
                    phone_login: true,
                    reset_pwd: true,
                },
                qrLogin:{
                    image_captcha: true,
                    captcha: true,
                }
            },
            courseInfo:{
                keMenu: {
                    jieshao: true,
                    shipin: true,
                    ziliao: true,
                    biji: true,
                    taolun: true,
                    tiku: true,
                    zuoye: false,
                },
            },
            course_info: {
                exam_list: {
                    list: {
                        fraction: true,
                        remark: true,
                        result: true,
                        join_test: true,
                    }
                },
                test:{
                    location: {
                        exam_list: true,
                    },
                    open: {
                        up_img: true,
                    },
                    universal: {
                        open: {
                            up_img: true,
                        }
                    },
                    onblur:false
                },
                exercise:{
                    location: {
                        exam_list: true,
                    },
                    open: {
                        up_img: true,
                    },
                    universal: {
                        open: {
                            up_img: true,
                        }
                    }
                }
            },
            userCenter:{
                index:{
                    attestation: true,
                    purchased: true,
                }
            },
            footer:{
                show: true,
            }
        },
        // 获取账号注册信息
        user_relation_count:'',
        // 常量
        const: "",
        // 学籍数量
        register_count: 0,
    },
    mutations: {
        temp(state,val) {
            return eval(`state.template.${val.key} = val.value`)
        },
        change_vuex(state,val) {
            return state[val.key] = val.value
        },
        defaultIndex(state,val){
            return state.defaultIndex = val
        },
        qiFocus(state,val){
            return state.qiFocus = val
        },
        //that.$store.commit("qiFocus","focus")
        activeIndex(state,val){
            return state.activeIndex = val
        },
        get_is_expire(state, res){
            return state.pwd_exp_check = res
        },
        research_institute(state,val){
            return state.research_institute = val
        },
        app_config(state, val){
            return state.app_config = val
        },
        identity_list(state, val){
            return state.identity_list = val
        },
        user_relation_count(state, val){
            return state.user_relation_count = val
        },
    },
    // 属性四：actions 用来处理异步  返回的是mutations并不是具体的值
    actions: {
        //获取密码过期
        get_is_expire(store){
            return new Promise((resolve, reject) => {
                if( !store.state.pwd_exp_check && VueCookies.get("token")){
                    ajax.get(global.serverSrc + global.qianzui + '/password/password_expire_check').then(res=>{
                        store.commit("get_is_expire", res.data.data)
                        resolve(res.data.data)
                    })
                }else{
                    store.commit("get_is_expire", store.state.pwd_exp_check)
                    resolve(store.state.pwd_exp_check)
                }
            });
    
        },
        //获取当前平台
        get_app_config(store){
            if(process.env.NODE_ENV == 'production'){
                store.commit("change_vuex", {
                    key: 'app_config_load',
                    value: true
                })
            }
            return new Promise((resolve, reject) => {
                if(!store.state.app_config.platform_code){
                    ajax.get(global.serverSrc + global.qianzui + '/setting/get_app_config').then(res=>{
                        store.commit("app_config", res.data.data)
                        resolve(res.data.data)
                    })
                }else{
                    store.commit("app_config", store.state.app_config)
                    resolve(store.state.app_config)
                }
            });
        },
        //获取学籍信息
        get_identity_list(store){
            return new Promise((resolve, reject) => {
                if( !store.state.identity_list.length && VueCookies.get("token")){
                    ajax.get(global.serverSrc + global.qianzui + '/member/identity_list').then(res=>{
                        store.commit("identity_list", res.data.data)
                        resolve(res.data.data)
                    })
                }else{
                    store.commit("identity_list", store.state.identity_list)
                    resolve(store.state.identity_list)
                }
            });
        },
        //获取常量
        get_const(store){
            return new Promise((resolve, reject) => {
                // if( !store.state.const){
                    ajax.get(global.serverSrc + global.qianzui + '/const').then(res=>{
                        let resData = res.data
                        if(resData.code == 0){
                            store.commit("change_vuex", {
                                key:"const",
                                value: resData.data
                            })
                            resolve(resData.data)
                        }
                    })
                // }else{
                    // store.commit("change_vuex", {
                    //     key:"const",
                    //     value: store.state.const
                    // })
                    // resolve(store.state.const)
                // }
            });
    
        },
        //获取账号注册信息
        get_user_relation_count(store){
            return new Promise((resolve, reject) => {
                if(!store.state.user_relation_count){
                    ajax.get(global.serverSrc + global.qianzui + '/user_relation/count').then(res=>{
                        store.commit("user_relation_count", res.data.data)
                        store.commit("change_vuex",{
                            key:"register_count",
                            value: res.data.data.register_count
                        })
                        resolve(res.data.data)
                    })
                }else{
                    store.commit("user_relation_count", store.state.user_relation_count)
                    store.commit("change_vuex",{
                        key:"register_count",
                        value: store.state.user_relation_count.register_count
                    })
                    resolve(store.state.user_relation_count)
                }
            });
        },
    },
})

export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js